/* eslint-disable no-console */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Home from './../pages/Home';
import Login from './../pages/Login';
import Signup from './../pages/Signup';
import Recover from './../pages/Recover';
import Reset from './../pages/Reset';

import Profile from './../pages/users/Profile';
import Users from './../pages/users/List';
import User from './../pages/users/Form';

import Logs from './../pages/logs/List';
import Log from './../pages/logs/Details';

import Main from './../layouts/Main';
import { isLogged } from './../guards/logged';

const routes = [
  { path: '/login', component: Login, name: 'Login' },
  { path: '/signup', component: Signup, name: 'Signup' },
  { path: '/recover', component: Recover, name: 'Recover' },
  { path: '/reset/:token', component: Reset, name: 'Reset' },
  { 
    path: '', component: Main,
    children: [
      {
        path: '',
        component: Home,
        alias: '/home', 
        name: 'Home'
      },

      {
        path: 'profile',
        component: Profile,
        name: 'Profile'
      },

      {
        path: 'users',
        component: Users, 
        name: 'Users'
      },
      {
        path: 'users/:id',
        component: User,
        alias: '/users/me', 
        name: 'User'
      },

      {
        path: 'logs',
        component: Logs,
        //alias: '/home', 
        name: 'Logs'
      },
      {
        path: 'logs/:id',
        component: Log,
        alias: '/logs/new', 
        name: 'Log'
      },
      // {
      //   // UserPosts will be rendered inside User's <router-view>
      //   // when /user/:id/posts is matched
      //   path: 'posts',
      //   component: UserPosts
      // }
    ]
  }
];

const router = new VueRouter({
  routes, // short for `routes: routes`
  mode: 'history'
});

router.beforeEach(async (to, from, next) => {
  let isAuth = await isLogged();
  
  if ((to.name !== 'Login' && to.name !== 'Signup' && to.name !== 'Recover' && to.name !== 'Reset') && !isAuth){
    next({ name: 'Login' })
  } 
  else {
    next()
  }
});

export default router;